import { createFileRoute } from "@tanstack/react-router";
import { getSignIn } from "@/features/identity/records";
import { returnSearchSchema } from "@/features/identity/navigation";
import { SignInPage } from "@/features/identity";

export const Route = createFileRoute("/_site/sign-in")({
  validateSearch: returnSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ deps, abortController }) =>
    getSignIn({ data: deps, signal: abortController.signal }),
  gcTime: 0,
  head: () => ({
    meta: [
      { title: "Softmax - Sign In" },
      { name: "description", content: "Sign in to continue to Softmax." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: SignInRoute,
});

function SignInRoute() {
  return <SignInPage {...Route.useLoaderData()} />;
}
